import React from 'react';
import PropTypes from 'prop-types';
import SentimentSlider from 'zignal-widgets/lib/SentimentSlider';
import ToolTip from 'zignal-landscape/lib/ToolTip';
import styles from './WorkbenchSentimentSelect.css';

const WorkbenchSentimentSelect = ({
  selectedIndex = 0,
  onSelectedIndexChanged = () => undefined,
  disabled = false,
  disabledTooltip = undefined
}) => {

  const selectedValue = selectedIndex === 0 ? undefined : selectedIndex - 4;

  const slider = (
    <div className={styles.container} tabIndex="0">
      <div className={styles.caption} />
      <SentimentSlider
        selectedValue={selectedValue}
        onChange={disabled ? undefined : (value) => onSelectedIndexChanged(value + 4)}
        captionStyle="workbenchCaption"
        disabled={disabled}
      />
    </div>
  );

  if (disabled && disabledTooltip) {
    return (
      <ToolTip position="top" tooltipText={disabledTooltip}>
        {slider}
      </ToolTip>
    );
  }

  return slider;
};

WorkbenchSentimentSelect.propTypes = {
  selectedIndex: PropTypes.number,
  onSelectedIndexChanged: PropTypes.func,
  disabled: PropTypes.bool,
  disabledTooltip: PropTypes.node
};

export default WorkbenchSentimentSelect;
